import { API } from '../api'
import { DownloadParams } from './interface'

export const post = async (
  filtros: Record<string, any>
): Promise<{
  conteudo: string
  sucesso: boolean
  erros: string[]
}> => {
  try {
    const formData = new FormData()
    filtros.forEach(id => {
      formData.append('idsItens[]', id || null)
    })

    const response = await API.post<DownloadParams>(
      '/logistica/item/relatorio-logistico',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )

    return {
      conteudo: response.content,
      sucesso: response.isSuccess,
      erros: []
    }
  } catch (error) {
    console.error('Erro ao solicitar donwload:', error)
    return null
  }
}
